"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReplyMessageContext = void 0;
const react_1 = require("react");
exports.ReplyMessageContext = (0, react_1.createContext)({});
